var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "profile" }, [
    _c("div", { staticClass: "profile-wrapper" }, [
      _c("div", { staticClass: "profile-content" }, [
        _c("div", { staticClass: "profile-data" }, [
          _c("div", { staticClass: "profile-name" }, [
            _vm._v(_vm._s(_vm.profile.name)),
          ]),
          _c("div", { staticClass: "profile-positions" }, [
            _vm._v(_vm._s(_vm.positions)),
          ]),
        ]),
        _c("div", { staticClass: "profile-stats" }, [
          _vm._m(0),
          _c("div", { staticClass: "profile-stats__item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("сотр.")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(
                _vm._s(_vm.profile.stats.employee.tabs) +
                  "/" +
                  _vm._s(_vm.profile.stats.employee.fields) +
                  ","
              ),
            ]),
          ]),
          _c("div", { staticClass: "profile-stats__item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("канд.")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(
                _vm._s(_vm.profile.stats.candidate.tabs) +
                  "/" +
                  _vm._s(_vm.profile.stats.candidate.fields) +
                  ","
              ),
            ]),
          ]),
          _c("div", { staticClass: "profile-stats__item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("кр. канд.")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(
                _vm._s(_vm.profile.stats.shortCandidate.tabs) +
                  "/" +
                  _vm._s(_vm.profile.stats.shortCandidate.fields)
              ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "profile-actions" },
        [
          _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.hover.blur.top",
                value: "Редактировать",
                expression: "'Редактировать'",
                modifiers: { hover: true, blur: true, top: true },
              },
            ],
            staticClass: "profile-edit",
            attrs: { size: "iconic", icon: "edit" },
            on: {
              click: function ($event) {
                return _vm.$router.push({
                  name: "edit-profile",
                  params: { id: _vm.profile.id },
                })
              },
            },
          }),
          _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.hover.blur.top",
                value: "Удалить",
                expression: "'Удалить'",
                modifiers: { hover: true, blur: true, top: true },
              },
            ],
            staticClass: "profile-remove",
            attrs: {
              size: "iconic",
              icon: { icon: "trash", color: "secondary" },
            },
            on: {
              click: function ($event) {
                return _vm.$emit("remove")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "profile-stats__item" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Вкладки/поля")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }